import React from 'react';
import RegisterPaywallForm from './RegisterPaywallForm';
import styles from '../../login/LoginForm/LoginFormCont.module.css';

const RegisterPaywallFormCont = () => (
  <div className={styles['login-container']}>
    <header className={styles.header}>
      <h3 className={styles.title}> Preferences </h3>
      <p className={styles.des} />
      <h3 className={styles['email-header']}>Set your preference</h3>
      <hr />
    </header>
    <section>
      <RegisterPaywallForm />
    </section>
  </div>
);

export default RegisterPaywallFormCont;
